export const useTurnstile = () =>
{
    return {
        siteKey: "0x4AAAAAABm0iaeADp_8O4xL"
    };
};
